/*
//-------------------------------------------------------
//   Copyright (c) 2020 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     PortalRedirectTypes
//   Details:    PortalRedirectTypes constant
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 106380 30/04/20 JC       New
// 103839 13/05/20 JC  M01  Added teamPortal
//-------------------------------------------------------
*/

export const portalRedirectTypes = {
    managerPortal: 2
    ,teamPortal: 3 //M01
};
